// Adapter lưu trữ bài giảng. Phase B: localStorage (test không cần backend).
// Phase C: thay phần thân bằng gọi API /teacher/lessons — GIỮ NGUYÊN interface này.
import type { LessonDoc } from '../types/LessonDoc'
import { slugify } from './id'

const KEY = 'lesson_builder_library_v1'

function readAll(): LessonDoc[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]')
  } catch {
    return []
  }
}

function writeAll(list: LessonDoc[]): void {
  localStorage.setItem(KEY, JSON.stringify(list))
}

function ensureSlug(doc: LessonDoc): LessonDoc {
  if (doc.slug) return doc
  return { ...doc, slug: slugify(doc.meta.tieuDe) || doc.id }
}

export const lessonStorage = {
  list(): LessonDoc[] {
    return readAll().sort((a, b) => (b.updatedAt || '').localeCompare(a.updatedAt || ''))
  },

  get(id: string): LessonDoc | null {
    return readAll().find((l) => l.id === id) || null
  },

  getBySlug(slug: string): LessonDoc | null {
    return readAll().find((l) => l.slug === slug) || null
  },

  save(doc: LessonDoc): LessonDoc {
    const now = new Date().toISOString()
    const list = readAll()
    const withSlug = ensureSlug(doc)
    const i = list.findIndex((l) => l.id === withSlug.id)
    const updated: LessonDoc = { ...withSlug, updatedAt: now, createdAt: withSlug.createdAt || now }
    if (i >= 0) list[i] = updated
    else list.push(updated)
    writeAll(list)
    return updated
  },

  remove(id: string): void {
    writeAll(readAll().filter((l) => l.id !== id))
  },

  publish(id: string): LessonDoc | null {
    const list = readAll()
    const i = list.findIndex((l) => l.id === id)
    if (i < 0) return null
    list[i] = { ...list[i], status: 'published', updatedAt: new Date().toISOString() }
    writeAll(list)
    return list[i]
  },
}
